const FileLoadEvent = {
  triggerFileToLoad: (fileKeyToLoad: string) => window.dispatchEvent(new CustomEvent("fileToLoad", { detail: fileKeyToLoad })),
  triggerFileLoaded: (fileKeyLoaded: string) => window.dispatchEvent(new CustomEvent("fileLoaded", { detail: fileKeyLoaded }))
}

Object.freeze(FileLoadEvent);
export default FileLoadEvent;